import React, { Component } from 'react';
import styled from 'styled-components';

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  width: 100%;

  @media (max-width: ${(props) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
    flex-direction: column;
    gap: 16px;
  }

  .header-content-left {
    display: flex;
    flex-direction: column;
    font-family: ${(props) => props.theme.fonts.oswald};
    gap: 10px;
    width: 100%;
  }

  .header-title {
    color: #f4501c;
    font-size: 20px;
  }

  .header-container-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .header-subtitle {
    font-family: ${(props) => props.theme.fonts.oswald};
    font-size: calc(12px + 1vw);
    color: #2b3d54;
    text-transform: uppercase;

    span {
      color: #f4501c;
      font-size: 20px;
      text-transform: lowercase;
    }
  }

  .header-description {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    color: #2b3d54;
    line-height: 18px;
    font-size: 14px;
    margin-top: 6px;
  }

  .header-content-right {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: end;
    width: 100%;
    height: 100%;
  }

  .header-title-main-action {
    display: none;
    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      display: block;
    }
  }
  .header-children-main-action {
    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      display: none;
    }
  }
`;

class Header extends Component {
  render() {
    const { title, subTitle, content, children, mainActionComponent } =
      this.props;
    return (
      <HeaderContainer>
        <div className="header-content-left">
          <div className="header-container-title">
            <h2 className="header-title">{title}</h2>
            {mainActionComponent && (
              <div className="header-title-main-action">
                {mainActionComponent}
              </div>
            )}
          </div>
          <p className="header-subtitle">{subTitle}</p>
          {content && <span className="header-description">{content}</span>}
        </div>

        <div className="header-content-right">
          <div>
            <div className="header-children-main-action">
              {mainActionComponent}
            </div>
          </div>
          {children}
        </div>
      </HeaderContainer>
    );
  }
}

export default Header;
